import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";
import LazyOnView from "@/components/LazyOnView";

const Index = () => {
  const { i18n, t } = useTranslation();
  const isBg = i18n.language === "bg";

  const orgLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "@id": "https://bullgrape.com/#studio",
    name: "BULLGRAPE",
    url: "https://bullgrape.com",
    logo: "https://bullgrape.com/logo.png",
    image: "https://bullgrape.com/logo.png",
    email: "hello@bullgrape.com",
    priceRange: "$$",
    areaServed: "Worldwide",
    knowsLanguage: ["bg", "en"],
    description: isBg
      ? "BULLGRAPE е креативно дигитално студио в Пловдив. Създаваме уебсайтове, бранд идентичности, онлайн магазини, кампании, мобилни приложения и 3D / AR уеб преживявания."
      : "BULLGRAPE is a creative digital studio based in Plovdiv, Bulgaria. We build bespoke websites, brand identities, e-commerce platforms, campaigns, mobile apps and 3D / AR web experiences.",
    address: {
      "@type": "PostalAddress",
      streetAddress: "16A Bratya Miladinovi St.",
      addressLocality: "Harmanli",
      postalCode: "6450",
      addressCountry: "BG",
    },
    contactPoint: {
      "@type": "ContactPoint",
      email: "hello@bullgrape.com",
      contactType: "customer service",
    },
  };

  const websiteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "BULLGRAPE",
    url: "https://bullgrape.com",
    inLanguage: isBg ? "bg" : "en",
  };

  const faqItems = t("faq.items", { returnObjects: true }) as { q: string; a: string }[];
  const faqLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  const graphLd = {
    "@context": "https://schema.org",
    "@graph": [orgLd, websiteLd, faqLd],
  };

  return (
    <div className="bg-background text-foreground min-h-screen">
      <SEO
        title={
          isBg
            ? "BULLGRAPE | Уеб дизайн, брандинг и дигитално студио"
            : "BULLGRAPE | Web Design, Branding & Digital Studio"
        }
        description={
          isBg
            ? "Креативно дигитално студио в Пловдив. Уеб дизайн, брандинг, e-commerce, мобилни приложения и 3D / AR уеб преживявания."
            : "Creative digital studio in Plovdiv building websites, brand identities, e-commerce, mobile apps and 3D / AR web experiences."
        }
        ogDescription={
          isBg
            ? "Креативно дигитално студио в Пловдив за уеб дизайн, брандинг, e-commerce, мобилни приложения и 3D / AR уеб преживявания."
            : "Creative digital studio in Plovdiv building websites, brand identities, e-commerce, mobile apps and 3D / AR web experiences."
        }
        canonical="/"
        jsonLd={graphLd}
      />
      <Navbar />
      {typeof window !== "undefined" &&
        window.matchMedia("(pointer: fine)").matches &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches && (
          <LazyOnView load={() => import("@/components/MouseTrailLine")} minHeight="0px" />
        )}
      <Hero />
      <LazyOnView load={() => import("@/components/Work")} />
      <LazyOnView load={() => import("@/components/Services")} />
      <LazyOnView load={() => import("@/components/ForWhom")} />
      <LazyOnView load={() => import("@/components/Process")} />
      <LazyOnView load={() => import("@/components/About")} />
      <LazyOnView load={() => import("@/components/FAQ")} />
      <LazyOnView load={() => import("@/components/Contact")} />
    </div>
  );
};

export default Index;
